import React, { FC, useContext, useEffect } from "react";
import { PrimaryHeader } from "../../components/header/primary";
import { DashboardHeaderContext } from "../../../hook/header";
import { ByRequestGoodsControlGroup } from "./request";
import { useStyleContext } from "../../context/StyleContext";
export const GoodsControlGroupPage: FC = () => {
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  const { stylePage } = useStyleContext();
  /* eslint-disable */
  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-secondary-header",
      title: "Control de Bienes y Equipos",
      dark: true,
    });
  }, []);
  /* eslint-enable */

  return (
    <div className={"w-full overflow-x-hidden"} style={stylePage}>
      <PrimaryHeader
        breadcrumbItems={[
          {
            label: "Control de Bienes y Equipos",
            active: true,
          },
        ]}
        title={"Control de Bienes y Equipos"}
      />
      <div className={"w-full p-3"}>
        <ByRequestGoodsControlGroup />
      </div>
    </div>
  );
};
